import { Spin } from "antd";
import { useEffect, useState } from "react";
import EditButton from "../../../components/buttons/edit";
import MotoristaForm from "../../../components/motoristas/form";
import {
    InlineContainer,
    TitleHeader,
    VerticalContainer,
} from "../../../components/styled";
import ViewContainer from "../../../components/view_container";
import { getMorotista, getMotorista, updateMotorista } from "../../../services/motoristas";

export default function EditMotorista({ computedMatch }) {
  const [error, setError] = useState();
  const [motorista, setMotorista] = useState();
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const { params } = computedMatch;
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateMotorista(motorista, values);
    } catch (err) {
      console.log(err);
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  const handleMotorista = async () => {
    const data = await getMotorista(params.id);
    setMotorista(data);
  };

  useEffect(() => {
    handleMotorista();
  }, []);

  return (
    <>
      {motorista ? (
        <VerticalContainer>
          <InlineContainer>
            <TitleHeader></TitleHeader>
            <EditButton viewMode={viewMode} setViewMode={setViewMode} />
          </InlineContainer>

          <ViewContainer item={motorista}>
            <MotoristaForm
              initialValues={{ ...motorista }}
              onFinish={onFinish}
              error={error}
              setError={setError}
              loading={loading}
              viewMode={viewMode}
            />
          </ViewContainer>
        </VerticalContainer>
      ) : (
        <Spin />
      )}
    </>
  );
}
